import { __extends, __values } from "tslib";
/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as React from 'react';
import { TypeRegistrar } from "igniteui-react-core";
import { brushToString, stringToBrush, isValidProp, getModifiedProps, toSpinal, initializePropertiesFromCss, NamePatcher } from "igniteui-react-core";
import { XamRadialGaugeRange } from "./XamRadialGaugeRange";
var IgrRadialGaugeRange = /** @class */ /*@__PURE__*/function (_super) {
  __extends(IgrRadialGaugeRange, _super);
  function IgrRadialGaugeRange(props) {
    var _this = _super.call(this, props) || this;
    _this._renderer = null;
    _this.__p = null;
    _this._hasUserValues = new Set();
    _this._stylingContainer = null;
    _this._stylingParent = null;
    _this._inStyling = false;
    if (_this._styling) {
      NamePatcher.ensureStylablePatched(Object.getPrototypeOf(_this));
    }
    _this._implementation = _this.createImplementation();
    _this._implementation.externalObject = _this;
    _this.onImplementationCreated();
    return _this;
  }
  Object.defineProperty(IgrRadialGaugeRange.prototype, "i", {
    get: function get() {
      return this._implementation;
    },
    enumerable: false,
    configurable: true
  });
  IgrRadialGaugeRange.prototype.onImplementationCreated = function () {};
  IgrRadialGaugeRange.prototype.componentDidMount = function () {
    var e_1, _a;
    try {
      for (var _b = __values(Object.keys(this.props)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var p = _c.value;
        if (isValidProp(this, p)) {
          {
            this[p] = this.props[p];
          }
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };
  IgrRadialGaugeRange.prototype.shouldComponentUpdate = function (nextProps, nextState) {
    var e_2, _a;
    var mod = getModifiedProps(this.props, nextProps);
    try {
      for (var _b = __values(Object.keys(mod)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var p = _c.value;
        if (isValidProp(this, p)) {
          this[p] = mod[p];
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    return true;
  };
  IgrRadialGaugeRange.prototype.render = function () {
    return null;
  };
  Object.defineProperty(IgrRadialGaugeRange.prototype, "rangeInternal", {
    get: function get() {
      return this.i;
    },
    enumerable: false,
    configurable: true
  });
  IgrRadialGaugeRange.prototype.createImplementation = function () {
    return new XamRadialGaugeRange();
  };
  IgrRadialGaugeRange.prototype._provideRenderer = function (renderer) {
    this._renderer = renderer;
  };
  IgrRadialGaugeRange._createFromInternal = function (internal) {
    if (!internal) {
      return null;
    }
    if (!internal.$type) {
      return null;
    }
    var name = internal.$type.name;
    var externalName = "Igr" + name;
    if (!TypeRegistrar.isRegistered(externalName)) {
      return null;
    }
    return TypeRegistrar.create(externalName);
  };
  Object.defineProperty(IgrRadialGaugeRange.prototype, "name", {
    /**
    * Gets or sets the name of the range.
    */
    get: function get() {
      return this.i.v;
    },
    set: function set(v) {
      this.i.v = v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrRadialGaugeRange.prototype, "brush", {
    /**
     * Gets or sets the brush to use to fill the range.
    */
    get: function get() {
      return brushToString(this.i.ao);
    },
    set: function set(v) {
      this.i.ao = stringToBrush(v);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrRadialGaugeRange.prototype, "outline", {
    /**
     * Gets or sets the outline to use when rendering the range.
    */
    get: function get() {
      return brushToString(this.i.ap);
    },
    set: function set(v) {
      this.i.ap = stringToBrush(v);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrRadialGaugeRange.prototype, "startValue", {
    /**
     * Gets or sets the value at which the range starts along the scale.
    */
    get: function get() {
      return this.i.o;
    },
    set: function set(v) {
      this.i.o = +v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrRadialGaugeRange.prototype, "endValue", {
    /**
     * Gets or sets the value at which the range ends along the scale.
    */
    get: function get() {
      return this.i.j;
    },
    set: function set(v) {
      this.i.j = +v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrRadialGaugeRange.prototype, "innerStartExtent", {
    /**
     * Gets or sets the distance from the center of the gauge (from 0 to 1) at which to start rendering the inner sweep of the range.
     * Values further from zero than 1 can be used to make this extend further than the normal radius of the gauge.
    */
    get: function get() {
      return this.i.l;
    },
    set: function set(v) {
      this.i.l = +v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrRadialGaugeRange.prototype, "innerEndExtent", {
    /**
     * Gets or sets the distance from the center of the gauge (from 0 to 1) at which to end rendering the inner sweep of the range.
     * Values further from zero than 1 can be used to make this extend further than the normal radius of the gauge.
    */
    get: function get() {
      return this.i.k;
    },
    set: function set(v) {
      this.i.k = +v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrRadialGaugeRange.prototype, "outerStartExtent", {
    /**
     * Gets or sets the distance from the center of the gauge (from 0 to 1) at which to start rendering the outer sweep of the range.
     * Values further from zero than 1 can be used to make this extend further than the normal radius of the gauge.
    */
    get: function get() {
      return this.i.n;
    },
    set: function set(v) {
      this.i.n = +v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrRadialGaugeRange.prototype, "outerEndExtent", {
    /**
     * Gets or sets the distance from the center of the gauge (from 0 to 1) at which to end rendering the outer sweep of the range.
     * Values further from zero than 1 can be used to make this extend further than the normal radius of the gauge.
    */
    get: function get() {
      return this.i.m;
    },
    set: function set(v) {
      this.i.m = +v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrRadialGaugeRange.prototype, "strokeThickness", {
    /**
     * Gets or sets the stroke thickness to use when rendering this range's outline.
    */
    get: function get() {
      return this.i.p;
    },
    set: function set(v) {
      this.i.p = +v;
    },
    enumerable: false,
    configurable: true
  });
  IgrRadialGaugeRange.prototype.findByName = function (name) {
    return null;
  };
  Object.defineProperty(IgrRadialGaugeRange.prototype, "hasUserValues", {
    get: function get() {
      return this._hasUserValues;
    },
    enumerable: false,
    configurable: true
  });
  IgrRadialGaugeRange.prototype.__m = function (propertyName) {
    if (!this._inStyling) {
      this._hasUserValues.add(propertyName);
    }
  };
  IgrRadialGaugeRange.prototype._styling = function (container, component, parent) {
    if (this._inStyling) {
      return;
    }
    this._inStyling = true;
    this._stylingContainer = container;
    this._stylingParent = component;
    var genericPrefix = "";
    var typeName = this.i.$type.name;
    if (typeName.indexOf("Xam") === 0) {
      typeName = typeName.substring(3);
    }
    genericPrefix = toSpinal("RadialGaugeRange");
    var additionalPrefixes = [];
    var prefix = toSpinal(typeName);
    additionalPrefixes.push(prefix + "-");
    var b = this.i.$type.baseType;
    while (b && b.name != "Object" && b.name != "Base" && b.name != "Control" && b.Name != "DependencyObject" && b.Name != "FrameworkElement") {
      typeName = b.name;
      if (typeName.indexOf("Xam") === 0) {
        typeName = typeName.substring(3);
      }
      var basePrefix = toSpinal(typeName);
      additionalPrefixes.push(basePrefix + "-");
      b = b.baseType;
    }
    if (parent) {
      var parentTypeName = parent.i.$type.name;
      if (parentTypeName.indexOf("Xam") === 0) {
        parentTypeName = parentTypeName.substring(3);
      }
      var parentPrefix = toSpinal(parentTypeName);
      additionalPrefixes.push(parentPrefix + "-" + genericPrefix + "-");
      additionalPrefixes.push(parentPrefix + "-" + prefix + "-");
    }
    initializePropertiesFromCss(container, this, genericPrefix + "-", this.hasUserValues, false, additionalPrefixes);
    if (this._otherStyling) {
      this._otherStyling(container, component, parent);
    }
    this._inStyling = false;
  };
  return IgrRadialGaugeRange;
}(React.Component);
export { IgrRadialGaugeRange };